"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Mission";

export default {
  getAllMission() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllMission`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getMissionRoute(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/GetMissionRoute`, payload).result.then(
        ({ data }) => resolve(data)
      );
    });
  },
  getOneMission(missionId) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/GetOneMission`,
        `?missionID=${missionId}`
      ).then(({ data }) => resolve(data));
    });
  },
  saveMission(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveMission`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  deleteMission(missionId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/DeleteMission?entityID=${missionId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
